module.exports = __webpack_public_path__ + "img/Protección a Ocupantes.c70a9729.svg";